export default __webpack_public_path__ + "static/media/rating_1.8e423175.svg";